import React from "react"
export function SaudiArabiaFlag(props) {
  return (
    <svg viewBox="0 0 24 16" {...props}>
      <g
        id="prefix__Double-Color-Icons"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <g id="prefix__Saudi-Arabia" fillRule="nonzero">
          <g id="prefix__saudi-arabia">
            <path id="prefix__Rectangle" fill="#259245" d="M0 0h24v16H0z" />
            <g id="prefix__Group" transform="translate(4 2)" fill="#FFF">
              <path
                d="M12.9 9.5H12V9c0-.2-.2-.4-.4-.4s-.4.2-.4.4v.5h-8c-.2 0-.4.2-.4.4s.2.4.4.4h8v.5c0 .2.2.4.4.4s.4-.2.4-.4v-.5h.5v.1c0 .2.2.4.4.4s.4-.2.4-.4v-.5c0-.2-.2-.4-.4-.4zM5.2 3.3c.2 0 .4-.2.4-.4V1.1c0-.2-.2-.4-.4-.4s-.4.2-.4.4v1.8c0 .3.2.4.4.4z"
                id="prefix__Shape"
              />
              <path
                d="M4.1 4.8h1.1c.2 0 .4-.2.4-.4s-.1-.5-.4-.5H4.1V1.1c0-.2-.2-.4-.4-.4s-.4.2-.4.4v3.4c0 .5-.4.9-.9.9h-.1c-.2 0-.4-.1-.6-.3-.1-.1-.4-.1-.6 0-.2.1-.2.4 0 .6.3.3.8.5 1.2.5h.1c.9 0 1.5-.6 1.7-1.4zM14.6.7c-.2 0-.4.2-.4.4v3.4c0 .5-.4.9-.9.9-.1 0-.2 0-.3.1-.2.2-.2.4 0 .6.1.1.2.1.3.1h.1c.9 0 1.7-.8 1.7-1.8V1.1c-.1-.2-.3-.4-.5-.4zm-7.8 2c.3 0 .6-.1.9-.3.2.2.5.3.9.3s.6-.1.9-.3c.2.2.5.3.9.3.2 0 .4-.2.4-.4s-.2-.4-.4-.4-.4-.1-.5-.3c-.1-.1-.2-.2-.4-.2-.1 0-.3.1-.4.2-.1.2-.3.3-.5.3s-.5-.1-.6-.3c-.1-.1-.2-.2-.4-.2-.1 0-.3.1-.4.2-.1.2-.3.3-.5.3s-.4.2-.4.4.2.4.5.4zm4.9 3.5c.2 0 .4-.2.4-.4V1.3c0-.2-.2-.4-.4-.4s-.4.2-.4.4v4.5c0 .3.2.4.4.4zm-1.5-1.9c.2 0 .4-.2.4-.4s-.2-.4-.4-.4H7.9c-.2 0-.4.2-.4.4v.7c0 .5-.4.9-.9.9H5.2c-.2-.1-.4.1-.4.3 0 .2.2.4.4.4H6.6c.5 0 .9-.2 1.3-.6.3.4.8.6 1.3.6h.1c.1 0 .2 0 .3-.1.2-.2.2-.4 0-.6-.1-.1-.2-.1-.3-.1-.5 0-.9-.4-.9-.9v-.2h1.8zm2.9-1.6c.2 0 .4-.2.4-.4v-1c0-.2-.2-.4-.4-.4s-.4.2-.4.4v1c0 .2.2.4.4.4z"
                id="prefix__Shape"
              />
              <path
                d="M2.2 4.3c.2 0 .4-.2.4-.4V1.1c0-.2-.2-.4-.4-.4s-.5.2-.5.4v2.7c0 .3.2.5.5.5z"
                id="prefix__Path"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}
